import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01 ng-scope">
            <h1>{{ 'planning.Training applications' | translate }}</h1>
            <div class="clear">
                <a class="btn filter" ng-click="vm.showFilter = !vm.showFilter">{{ 'planning.Filter applications' | translate }}</a>
            </div>
        </div>
        <courses-application-filter list="vm.list" show-filter="vm.showFilter" fields="vm.fields"/>
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <table
                ng-init="vm.initBulk()"
                class="data01"
                datatable
                dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('course_name')">
                            <a ng-click="vm.list.sortBy('course_name')">{{ 'course.Course' | translate }}</a>
                        </th>
                        <th ng-class="vm.list.getSortClass('course_fields')">
                            <a ng-click="vm.list.sortBy('course_fields')">{{ 'course.Field' | translate }}</a>
                        </th>
                        <th ng-class="vm.list.getSortClass('apply_date')">
                            <a ng-click="vm.list.sortBy('apply_date')">{{ 'application.Application date' | translate }}</a>
                        </th>
                        <th ng-class="vm.list.getSortClass('employee_name')">
                            <a ng-click="vm.list.sortBy('employee_name')">{{ 'application.Applicant' | translate }}</a>
                        </th>
                        <th ng-class="vm.list.getSortClass('status')">
                            <a ng-click="vm.list.sortBy('status')">{{ 'application.Status' | translate }}</a>
                        </th>
                        <th ng-class="vm.list.getSortClass('is_added_to_occurrence')">
                            <a ng-click="vm.list.sortBy('is_added_to_occurrence')">{{ 'application.Added to occurrence' | translate }}</a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td>
                            <a ui-sref="authorized.courses.application.detail({ id: item.id, application: item })">
                                {{ item.course_name }}
                            </a>
                        </td>
                        <td>{{ item.course_fields }}</td>
                        <td>{{ vm.MomentService.formatDate(item.apply_date) }}</td>
                        <td>{{ item.employee_name }}</td>
                        <td>{{ vm.COURSE_APPLICATION_STATUS_ENUM.LABELS[item.status] }}</td>
                        <td>{{ vm.convertBooleanToYesOrNo(item.is_added_to_occurrence) }}</td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, ListFactory, DATATABLES, COURSE_APPLICATION_STATUS_ENUM, CLASSIFIER_ENUM,
                 CourseApplicationResource, ClassifierResource, MomentService, CourseService, ApplicationService) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.ListFactory = ListFactory;
        this.DATATABLES = DATATABLES;
        this.COURSE_APPLICATION_STATUS_ENUM = COURSE_APPLICATION_STATUS_ENUM;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.CourseApplicationResource = CourseApplicationResource;
        this.ClassifierResource = ClassifierResource;
        this.MomentService = MomentService;
        this.CourseService = CourseService;
        this.ApplicationService = ApplicationService;
    }

    $onInit () {
        this.ClassifierResource.query({ type: this.CLASSIFIER_ENUM.KEYS.FIELD, expand: 'activeI18n' }).$promise.then(fields => (this.fields = fields));
        this.list = this.ListFactory.createWithPagination(this.CourseApplicationResource.query.bind(this.CourseApplicationResource));
        this.list.fetch();
    }

    convertBooleanToYesOrNo (boolean) {
        return boolean ? this.$translate.instant('general.Yes') : this.$translate.instant('general.No');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/application/list/index.js